import { format, subDays } from 'date-fns';
import {
  AccessRequestDetails,
  GetBlacklistPermissionsResponse,
  PermissionItemsMap,
  RequestStatusType,
} from '../../hooks/useUserPermissions';

export const mockPermissions: PermissionItemsMap = {
  areaOverview: 'R',
  transactionSearchPage: 'R',
  employeesAndRolesPage: 'R',
  avatarManagementPage: 'R',
  kpiTargetsPage: 'R',
  chatBoxPage: 'R',
  profitAndLossPage: 'R',
  salesAnalysisPage: 'R',
  newMembersWidget: 'R',
  shareOfReceiptWidget: 'R',
  topSellingGarmentsWidget: 'R',
  salesPerformanceWidget: 'R',
  conversionRateWidget: 'R',
  avgPiecesPerReceiptWidget: 'R',
  avgPurchasePerReceiptWidget: 'R',
  areaComparisonWidget: 'R',
  customerFeedBackWidget: 'R',
  personalSettings: 'CRUD',
  kpiTargets: 'CRUD',
  areaCaps: 'CRUD',
  lockTargets: 'CRUD',
  highlightWidget: 'CRUD',
  financialPlanned: 'R',
  financialBudget: 'R',
  employeePermissions: 'RU',
  soldProductsPage: 'CRUD',
  productIndexSubindex: 'CRUD',
  blacklistPermissionsForArea: 'CRUD',
  queueLengthWidget: 'CRUD',
  queueLengthTillViewWidget: 'CRUD',
  scoShareOfReceipt: 'CRUD',
  orisCustomerWidget: 'CRUD',
  rfidApprovalsWidget: 'R',
  rfidSalesWidget: 'R',
  stockCountWidget: 'R',
  efficiencyWidget: 'R',
  storeInventoryCount: 'R',
  customerEngagementWidget: 'R',
  newAppCustomersWidget: 'R',
  salesInsightWidget: 'R',
  currencyConverter: 'R',
  helpASaleWidget: 'R',
  stockAccuracyWidget: 'R',
  conversionRateOverview: 'R',
  membersOverview: 'R',
  salesOverview: 'R',
  efficiencyOverview: 'R',
  rfidOverview: 'R',
  queueAndCustomerOverview: 'R',
  budgetAndPlanOverview: 'R',
  kpiTargetsOverview: 'R',
  getCountsOverview: 'R',
  areaResultPage: 'R',
  bopisWidget: 'R',
  salesOverviewPage: 'R',
  assetManagementWidget: 'R',
};

export const getBlacklistPermissionsMockResponse: GetBlacklistPermissionsResponse = {
  areaCode: 'SE Mälardalen',
  permissions: ['conversionRateWidget', 'topSellingGarmentsWidget', 'newMembersWidget'],
};

export const postBlacklistPermissionsMockResponse: GetBlacklistPermissionsResponse = {
  areaCode: 'SE Mälardalen',
  permissions: ['conversionRateWidget'],
};

export const mockAccessRequestResponse = {
  jobRoleCode: 'JR009',
  countryCode: 'SE',
  organizationId: '5230010',
  businessUnitId: '1323',
  organizationName: 'SE Stockholm',
  businessUnitName: 'Kids',
  brandId: 0,
};

const now = new Date();

const generateRequest = (
  id: string,

  requestDaysAgo: number,
  status: RequestStatusType,
  statusDaysAgo?: number,
) => ({
  id,
  upn: `test${id}@hm.com`,
  requestTimestamp: format(subDays(now, requestDaysAgo), "yyyy-MM-dd'T'HH:mm:ssxxx"),
  approverUpn: 'approver@hm.com',
  status,
  statusTimestamp: statusDaysAgo ? format(subDays(now, statusDaysAgo), "yyyy-MM-dd'T'HH:mm:ssxxx") : '',
  requestedAssignment: {
    suamRoleCode: '',
    locationCode: 'Additional',
    title: 'regionalManager',
    countryCode: 'SE',
    jobRoleCode: '3000263',
    brandId: 1,
    businessUnitId: `BusinessUnitId ${id}`,
    businessUnitName: `BusinessUnitName ${id}`,
    organizationId: `OrganizationId ${id}`,
    organizationName: `OrganizationName ${id}`,
    isActive: true,
  },
});

export const reviewRequests = [
  generateRequest('1001', 20, 'Pending', 20),
  generateRequest('1002', 28, 'Pending', 28),
];

export const approvedRequests = [
  generateRequest('1003', 370, 'Approved', 350),
  generateRequest('1004', 370, 'Approved', 362),
  generateRequest('1005', 370, 'Approved', 365),
];

export const rejectedRequests = [generateRequest('1006', 370, 'Rejected', 365)];

export const getAccessRequestData = (): AccessRequestDetails => {
  return {
    requests: [...reviewRequests, ...approvedRequests, ...rejectedRequests],
  };
};
